import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**
 * The pending two-step deposit session.
 *
 * Step 2 (merchant bank details + countdown) is restored from this one localStorage key, which is
 * why it outlives the page: the deposit page, the deactivate guard, app.component (session
 * restore on load) and the topbar (logout interception) all read it.
 *
 * Key name kept as template-02 wrote it — a member mid-deposit must not lose the session when
 * this build replaces the old one.
 */
@Injectable({
  providedIn: 'root'
})
export class NewTwostepDepositDataService {

  private LS_KEY = 'TwostepDeposit';

  private LEAVING_PAGE_MSG = 'Leaving this page will discard your payment progress. Would you like to continue your payment?';
  private SESSION_EXPIRED_MSG = 'Your deposit session has expired. Please submit a new deposit request again.';
  private REDIRECT_PAGE_MSG = 'You have an existing pending payment deposit. Would you like to continue your payment?';

  constructor(private router: Router) {}

  getTwostepDeposit(): string {
    return localStorage.getItem(this.LS_KEY);
  }

  storeLocalStorage(data: any): void {
    localStorage.setItem(this.LS_KEY, JSON.stringify(data));
  }

  clearLocalStorage(): void {
    localStorage.removeItem(this.LS_KEY);
  }

  clearLocalStorageAndReload(): void {
    this.clearLocalStorage();
    window.location.reload();
  }

  clearLocalStorageAndGoToHistory(): void {
    this.clearLocalStorage();
    this.router.navigateByUrl('/member/history');
  }

  getLeavingPageMsg(): string {
    return this.LEAVING_PAGE_MSG;
  }

  getSessionExpiredMsg(): string {
    return this.SESSION_EXPIRED_MSG;
  }

  getRedirectPageMsg(): string {
    return this.REDIRECT_PAGE_MSG;
  }
}
